import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useSize } from '../../../services/hooks/useSize';
import styles from './autoSizeCard.module.css';
import { Card } from './card';

export const AutoSizeCard = ({children, className = '', style = {}, ...props}) => {

    const { ref, size } = useSize();
    
    const cardRef = useRef();
    const [padding, setPadding] = useState(0);
    const [margin, setMargin] = useState(0);

    useEffect(() => {
        if (!cardRef.current) return;

        const cs = window.getComputedStyle(cardRef.current);

        setPadding(
            convertPxStrToFloat(cs.getPropertyValue('padding-top')) +
            convertPxStrToFloat(cs.getPropertyValue('padding-bottom'))
        );

        setMargin(
            convertPxStrToFloat(cs.getPropertyValue('margin-top')) +
            convertPxStrToFloat(cs.getPropertyValue('margin-bottom'))
        );
    }, [cardRef]);


    return <Card
        ref={cardRef}
        className={styles.AutoSizeCard + ' ' + className}
        style={{
            // Add padding on both sides, then subtract the 24 inch that will be gained by the last row (that we don't get padding from)
            '--span-rows': Math.ceil(((size.innerHeight + padding + margin - 24) / (24 + 48))) + 1,
            ...style
        }}
        {...props}
    >
        <div className={styles.ContentWrapper} ref={ref}>
            {children}
        </div>
    </Card>;
}

const convertPxStrToFloat = pxStr => parseFloat(pxStr.slice(0, -2));